export const AboutPage = {
  title: 'About us',
  heading: 'Marketing that speaks your industry',
  description: 'We work only with facade installers and manufacturers, so your marketing speaks the language your clients use.',
};

export const Story = {
  title: 'Why we started',
  paragraphs: [
    'Facade companies do complex, highly visible work, yet most of it never shows up in their marketing.',
    'General marketing agencies spend months learning the difference between a unitized curtain wall and a storefront. By then, the budget is gone and the message still misses.',
    'We focus on one industry, so we start with that knowledge and spend your budget on the work that brings in projects.',
  ],
};

export const Principles = {
  title: 'What we hold ourselves to',
  description: 'Four commitments that apply to every client, whatever their size.',
  items: [
    { title: 'One industry, done well', description: 'We only work with facade installers and manufacturers, and it shows in every piece we produce.' },
    { title: 'A plan before any spending', description: "Nothing starts until you've approved the plan, the price, and any ad budget." },
    { title: 'Numbers you can check', description: 'Monthly reports show leads, meetings, and bid invites, not vanity metrics.' },
    { title: 'Your assets stay yours', description: 'Photos, copy, websites, and ad accounts belong to your company.' },
  ],
};

export const Roles = {
  title: 'How we fit into your team',
  description: 'You stay in control of your brand and your clients. We take the marketing work off your desk.',
  groups: [
    {
      title: 'Your team keeps',
      highlighted: false,
      items: ['Relationships with contractors and architects', 'Pricing and bid decisions', 'Approval of everything we publish', 'Your brand and your voice'],
    },
    {
      title: 'We handle',
      highlighted: true,
      items: ['Strategy and planning', 'Content, design, and campaigns', 'Your website and search presence', 'Reporting and lead follow-up'],
    },
  ],
};

export const Quality = {
  title: 'How we measure results',
  description: 'Marketing is only worth it if it brings in work. These are the numbers we track for every client.',
  checklistTitle: 'What your monthly report covers',
  checklist: [
    'Qualified leads and where they came from',
    'Meetings booked with contractors, architects, and owners',
    'Bid invites and specification requests',
    'Website and search performance',
    'What changes next month, and why',
  ],
};

export const AboutCta = {
  title: 'Ready to see what marketing can do for your company?',
  description: "Tell us about your company, and we'll reply with a marketing plan and a price.",
};